// extracted by mini-css-extract-plugin
export var buttonPanel = "styles-module__buttonPanel___qKxiF";
export var circleIcon = "styles-module__circleIcon___D3CoI";
export var lastCircleButton = "styles-module__lastCircleButton___SJ_C3";
export var userImage = "styles-module__userImage___DRcRZ";